import type { RenovationMediaKind } from '@cc/types';

export const MEDIA_KINDS: RenovationMediaKind[] = [
  'INSPIRATION',
  'FLOOR_PLAN',
  'DRAWING',
  'GUIDE',
  'REFERENCE',
];

export const KIND_LABEL: Record<RenovationMediaKind, string> = {
  INSPIRATION: 'Inspiration',
  FLOOR_PLAN: 'Floor plan',
  DRAWING: 'Drawing',
  GUIDE: 'Guide',
  REFERENCE: 'Reference',
};
